// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"f74ec41ea078ca2bc131","873":"a9e3cae5b0e702921941"}[chunkId] + ".js";
};